import cx from "classnames";
import { TitleIcon } from "components/TitleIcon";
import type { Competitor } from "hooks/firestore/betting/useBetting";
import type { Title } from "hooks/graphql/useTitles";
import isEmpty from "lodash/isEmpty";
import React from "react";
import { Competitors } from "./Competitors";
import { LiveScores } from "./LiveScores";

import * as styles from "./Scoreboard.module.scss";
import { MatchPageSkeleton, ScoreboardSkeleton } from "../MatchPageSkeleton";

type ScoreboardProps = {
  home: Competitor;
  away: Competitor;
  title: Title;
  eventId: string;
  renderTopRightSlot: () => React.ReactNode;
  loading: boolean;
};

const SportIconTitle = ({
  title,
  withScoreboard,
}: { title: Title; withScoreboard?: boolean }) => (
  <div className={styles.titleSection}>
    <div
      className={cx(styles.icon, { [styles.withScoreboard]: withScoreboard })}
    >
      <TitleIcon title={title} svg className={styles.titleIcon} />
    </div>
    <div className={cx({ [styles.heading]: !withScoreboard })}>
      {title.name}
    </div>
  </div>
);

export const Scoreboard = ({
  home,
  away,
  title,
  eventId,
  renderTopRightSlot,
  loading,
}: ScoreboardProps) => {
  if (loading || !home || !away) return <MatchPageSkeleton />;

  // both competitors required for the scoreboard to appear
  const displayScores = !(isEmpty(home) || isEmpty(away));

  return (
    <>
      <div className={styles.header}>
        <SportIconTitle title={title} withScoreboard={displayScores} />
        <div>{renderTopRightSlot()}</div>
      </div>

      {displayScores && (
        <div className={styles.scoreboard}>
          <Competitors home={home} away={away} />
          <LiveScores eventId={eventId} />
        </div>
      )}
    </>
  );
};
